class MessageParser {
  constructor(actionProvider, state) {
    this.actionProvider = actionProvider;
    this.state = state;
  }

  parse(message) {
    const lowerCaseMessage = message.toLowerCase().trim();
    if (lowerCaseMessage.includes('hola')) {
      return this.actionProvider.handleGreet();
    } else if (
      (lowerCaseMessage.includes('todo') ||
        lowerCaseMessage.includes('bien') ||
        lowerCaseMessage.includes('como estas') ||
        lowerCaseMessage.includes('cómo estás')) &&
      lowerCaseMessage.endsWith('?')
    ) {
      return this.actionProvider.handleHowAreYou();
    } else if (
      lowerCaseMessage.includes('ama') ||
      (lowerCaseMessage.includes('amas') && lowerCaseMessage.endsWith('?'))
    ) {
      return this.actionProvider.handleSecretQuestion();
    } else {
      return this.actionProvider.handleUnknownQuestion();
    }
  }
}

export default MessageParser;
